import PropTypes from "prop-types";
import { alertTypePropType } from "../../../propTypes";

/**
 * Unified alert component for displaying messages with different types
 * Supports success, error, warning, and info variants
 *
 * @component
 * @param {Object} props
 * @param {string} props.message - Message to display
 * @param {string} [props.type="info"] - Alert type (success, error, warning, info)
 * @param {string} [props.className=""] - Additional CSS classes
 * @param {Function} [props.onClose] - Optional close handler
 * @param {boolean} [props.dismissible=false] - Show close button
 */
const Alert = ({ message, type = "info", className = "", onClose, dismissible = false }) => {
  const alertTypeClass =
    {
      success: "alert-success",
      error: "alert-danger",
      warning: "alert-warning",
      info: "alert-info",
    }[type] || "alert-info";

  return (
    <div
      className={`alert ${alertTypeClass} ${dismissible ? "alert-dismissible fade show" : ""} ${className}`}
      role="alert"
    >
      {message}
      {dismissible && onClose && (
        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
      )}
    </div>
  );
};

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  type: alertTypePropType,
  className: PropTypes.string,
  onClose: PropTypes.func,
  dismissible: PropTypes.bool,
};

export default Alert;
